export default __webpack_public_path__ + "static/media/icon_sun.029dcf89.svg";